export const PUBDASH = 'pubdash';
export const TAGS = [
  PUBDASH,
  'Users',
  'Tenants',
  'Regular Tenant Verifications',
  'Partner Verifications',
];
